import { Component, OnInit,ViewChild } from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {SelectionModel} from '@angular/cdk/collections';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { lang_leaderGo } from 'app/idiomas/i18n/leaderGo/leaderGo.lang';
import { lang_perfiles } from 'app/idiomas/i18n/perfiles/perfiles.lang';
import * as backInter from 'app/auth/auth-data.model';
import { IdiomasService } from 'app/main/wizard-leader/services/idiomas.service';
import { LeaderSelectService } from 'app/main/wizard-actionGO/services/leaderSele.service';
import { WizardActionService } from 'app/main/wizard-actionGO/services/wizard.service';
import {MatPaginator} from '@angular/material/paginator';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import {MatSort} from '@angular/material/sort';
import { MatSnackBar } from "@angular/material/snack-bar";

@Component({
  selector: 'app-select-leader',
  templateUrl: './select-leader.component.html',
  styleUrls: ['./select-leader.component.scss']
})
export class SelectActionLeaderComponent implements OnInit {

  pasoCompleto: boolean=false;
  cargando:boolean=true;
  filtrandoLide:boolean=false;
  lideresSeleccionados:boolean=false;
  notificacionesEmpresa=10;
  productoCertificar: any;
    displayedColumns: string[] = ['statusLogin','NameUser', 'email','Area','JobTitle','Localidad','NumberOfEmails','select'];
    displayedLeadersSele: string[] = ['NameUser', 'email','Hierarchy_B_L1'];
    dataSource: MatTableDataSource<any>;
    dataSourceActionSele: any;
    leadresActionSeleccionados:any[]=[];
    leadresActionGuardados:any[]=[];
    selection = new SelectionModel<any>(true, []);
    selectionUserLogin = new SelectionModel<any>(true, []);
    lideresActionGo:any[]=[];
    lideresCerAsoSave:any[]=[];
    filtroAbierto=false;
    busquedaLiaders="";
  descargado:boolean=false;
  idEmpresa=localStorage.getItem('companyID');
   @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
   @ViewChild(MatSort) sort: MatSort;
   leadresActionCargados:boolean=false;
  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    private idiomasService: IdiomasService,
    private leaderService: LeaderSelectService,
    private wizardService: WizardActionService,
    private snackBar: MatSnackBar,
  ) {
    lang_certificar.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    lang_leaderGo.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    lang_perfiles.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit() {
    this.obtieneCertificarActual();
  }


obtieneCertificarActual(){
  this.leaderService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
    let prodsCertificar:backInter.prodCert[] = data.productosCertificar;
    var BreakException = {};
    try {
        prodsCertificar.forEach( (producto) => {
          let fecha = producto.fechaCertificar;
          let idProducto = producto.idCertificar;
          if(fecha == parseInt(localStorage.getItem('fechaProducto')) && idProducto == localStorage.getItem('productoID')){
            this.productoCertificar = producto;
            console.log("*********************", this.productoCertificar);

          throw BreakException;
          }
        });
    } catch (e) {
        if (e !== BreakException) throw e;
    };
    //obtiene el status del paso idiomas del certificar vigente

      this.leaderService.getStatusIdioma(this.productoCertificar.idCertificar).subscribe( (data: backInter.getStatusIndiv) => {
        console.log('entro get paso idiomas producto normal',data);
        if(data.estatus === 3)
        this.pasoCompleto = true;
      });
      // setTimeout(() => {
      //   this.getLeadersActionGoSeleccionados();
      //
      // }, 2000);
      this.getLeadersActionGo(this.idEmpresa,this.productoCertificar.asociadoId);
  }, error  => {
    console.log("error al recuperar certificar vigente");
  });
}

getLeadersActionGo(idEmpresa:any,asociadoId:any){
  this.leaderService.getLeadersActionGoSql(idEmpresa,asociadoId).subscribe((data:any) => {
console.log('***********',data);
// this.cargando=false;
this.lideresActionGo=data.records;
if (this.lideresActionGo.length>0) {
this.dataSource = new MatTableDataSource(this.lideresActionGo);
setTimeout(() => this.dataSource.paginator = this.paginator);
setTimeout(() => this.dataSource.sort  = this.sort );
// this.dataSource.data.forEach(row => {
//   if (row.emailSend) {
//     console.log('lo encontro');
//     this.selection.select(row);
//   }
//     });

this.cargando=false;
}else{
  this.cargando=false;
}
// else{
//   console.log('Aún no  se han filtrado los lideres');
// }

  }, error  => {
    console.log("error al recuperar certificar vigente");
  });
}
// getLeadersActionGoSeleccionados(){
//   this.leaderService.getLeaderActionGo(this.idEmpresa,this.productoCertificar.asociadoId).subscribe((data:any) => {
// console.log('***********leaders ya seleccionados',data);
// this.leadresActionGuardados=data.records;
// if (this.leadresActionGuardados.length>0) {
//   this.leadresActionCargados=true;
// }else{
//   this.leadresActionCargados=false;
// }
// this.dataSourceActionSele = new MatTableDataSource(this.leadresActionGuardados);
//
//
// this.leadresActionGuardados.forEach(hierarchiGua => {
//   this.dataSource.data.forEach(row => {
//     if (hierarchiGua.IdUser== row.IdUser) {
//       console.log('lo encontro');
//       this.selection.select(row);
//     }
//       });
//
// });
//   }, error  => {
//     console.log("error al recuperar certificar vigente");
//   });
// }


  /** Whether the number of selected elements matches the total number of rows. */
 isAllSelected() {
   const numSelected = this.selection.selected.length;
   const numRows = this.dataSource.data.length;
   return numSelected === numRows;

 }

 isAllSelectedLogin() {
   const numSelected = this.selectionUserLogin.selected.length;
   const numRows = this.dataSource.data.length;
   return numSelected === numRows;

 }

 masterToggle() {
   console.log('dataSource',this.dataSource);

     if(this.busquedaLiaders=="") {
       this.isAllSelected() ?
        this.selection.clear() :
          this.dataSource.data.forEach(row => this.selection.select(row));
        }else{
          this.isAllSelected() ?
           this.selection.clear() :
          this.dataSource.filteredData.forEach(row => this.selection.select(row));
        }
  }

 masterToggleLogin() {
   console.log('dataSource',this.dataSource);

     if(this.busquedaLiaders=="") {
       this.isAllSelected() ?
        this.selectionUserLogin.clear() :
          this.dataSource.data.forEach(row => this.selectionUserLogin.select(row));
        }else{
          this.isAllSelected() ?
           this.selectionUserLogin.clear() :
          this.dataSource.filteredData.forEach(row => this.selectionUserLogin.select(row));
        }
  }

  checkboxLabel(row?: any): string {
    // console.log('no se que hace 1',row);

      if (!row) {
        // console.log('no se que hace 2',row);
        return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
      }
      // console.log('no se que hace 3',row);
      return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
    }
  checkboxLabelLogin(row?: any): string {
    // console.log('no se que hace 1',row);

      if (!row) {
        // console.log('no se que hace 2',row);
        return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
      }
      // console.log('no se que hace 3',row);
      return `${this.selectionUserLogin.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
    }



  completarPaso(){
    let warni:any;
    let ok:any;
    let confir:any;
    let si:any;
    let no:any;
    this.translateSrv.get('LEADER_GO.SECCION_SELECT_LEADER.WARNI_NO_SELEC').subscribe((res: string) => { warni = res; });
    this.translateSrv.get('LEADER_GO.SECCION_SELECT_LEADER.BTN_CONFI_OK').subscribe((res: string) => { ok = res; });
    this.translateSrv.get('LEADER_GO.SECCION_SELECT_LEADER.COMFI_COMP_PAS').subscribe((res: string) => { confir = res; });
    this.translateSrv.get('LEADER_GO.SECCION_SELECT_LEADER.BTN_CONFI_YES').subscribe((res: string) => { si = res; });
    this.translateSrv.get('LEADER_GO.SECCION_SELECT_LEADER.BTN_CONFI_NO').subscribe((res: string) => { no = res; });
if (!this.leadresActionCargados) {
  Swal.fire({
  icon: 'warning',
  title: warni,
  showConfirmButton: true,
  confirmButtonText: ok,
  })
}else{
  Swal.fire({
    title: confir,
    icon: 'warning',
    showCancelButton: true,
reverseButtons: true,

    confirmButtonText: si,
    cancelButtonText: no
  }).then((result) => {
    if (result.value) {
      let datos:any={
          accionText:'',
          productoId:this.productoCertificar.idCertificar,
          leaderSelect: 3,
          userAdministrator:'',
          actualizar: 1,
      }
      console.log('*********** completar paso ',datos);

      this.leaderService.guardaStatusLeaderSelect(datos).subscribe( (data: backInter.RespuestaGen) => {
        if(data.message == '218'){

          this.pasoCompleto = true;
          this.enviaOrdenWizard();
        };
      });
    }
  });
}

    }

    enviaOrdenWizard(){
      this.wizardService.puenteDatosActionGo("100"); //100 = actualiza los status de los steps
    }

    applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
    console.log('this.dataSource.filter',this.dataSource.filter);

  }

  exportTable(){
    // Swal.showLoading()
    var wb = XLSX.utils.book_new();
    wb.Props = {
      // Title: this.translateSrv.instant("COLABORADORES.EXCEL.TITUARCHIVO"),
      Title: 'sdcmask',
      Subject: 'CULTURAL GO',
      Author: 'ITBM',
      CreatedDate: new Date()
    };
    wb.SheetNames.push('hoja');
    var ws_data = [];
    let nombresColumnas:string[] = [];
    backInter.CLAVES_COLUMNASLEADERS.forEach( (nombre) => {
      switch(nombre){
        case 'NameUser': nombresColumnas.push(this.translateSrv.instant('ACTION_GO.COLUMNAS.NameUser')); break;
        case 'email': nombresColumnas.push(this.translateSrv.instant('ACTION_GO.COLUMNAS.email')); break;
        case 'Area': nombresColumnas.push(this.translateSrv.instant('ACTION_GO.COLUMNAS.Area')); break;
        case 'JobTitle': nombresColumnas.push(this.translateSrv.instant('ACTION_GO.COLUMNAS.JobTitle')); break;
        case 'Localidad': nombresColumnas.push(this.translateSrv.instant('ACTION_GO.COLUMNAS.Localidad')); break;
        case 'NumberOfEmails': nombresColumnas.push(this.translateSrv.instant('ACTION_GO.COLUMNAS.NumberOfEmails')); break;
        case 'Pass_cgo': nombresColumnas.push(this.translateSrv.instant('ACTION_GO.COLUMNAS.Pass_cgo')); break;

      }
    });
    console.log("Colaboradores")
    ws_data.push(nombresColumnas);
    this.lideresActionGo.forEach( (leaders) => {
      let datosColaboradores:any[] = [];
      backInter.CLAVES_COLUMNASLEADERS.forEach( (nombre) => {
        switch(nombre){
          case 'NameUser': datosColaboradores.push(leaders.NameUser); break;
          case 'email': datosColaboradores.push(leaders.email); break;
          case 'Area': datosColaboradores.push(leaders.Area); break;
          case 'JobTitle': datosColaboradores.push(leaders.JobTitle); break;
          case 'Localidad': datosColaboradores.push(leaders.Localidad); break;
          case 'NumberOfEmails': datosColaboradores.push(leaders.NumberOfEmails); break;
          case 'Pass_cgo': datosColaboradores.push(leaders.Pass_cgo); break;
        }
      });
      ws_data.push(datosColaboradores);
      // console.log(ws_data);
    });
    var ws = XLSX.utils.aoa_to_sheet(ws_data);
    wb.Sheets['hoja'] = ws;
    var wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
    var buf = new ArrayBuffer(wbout.length); //convert s to arrayBuffer
    var view = new Uint8Array(buf);  //create uint8array as viewer
    for (var i=0; i<wbout.length; i++) view[i] = wbout.charCodeAt(i) & 0xFF; //convert to octet
    // saveAs(new Blob([buf],{type:"application/octet-stream"}), `${this.translateSrv.instant("COLABORADORES.EXCEL.TITUARCHIVO")}.xlsx`);
    saveAs(new Blob([buf],{type:"application/octet-stream"}), `${'LíderesActionGo'}.xlsx`);
    Swal.close();
  }
select2(){
  console.log('select2');

}

selectLoginUser(event:any,row,index:any){
  console.log('select2',row);
  console.log('event',event['checked']);

  let mensaje:any;
  if (event['checked']) {
  mensaje= this.translateSrv.instant('LEADER_GO.SECCION_SELECT_LEADER.MODAL_CONFI_ACTIV_USER_CGO');
}else{
  mensaje= this.translateSrv.instant('LEADER_GO.SECCION_SELECT_LEADER.MODAL_CONFI_DESACTIV_USER_CGO');

}
  Swal.fire({
    title: mensaje,
    icon: 'warning',
    showCancelButton: true,
    reverseButtons: true,
    confirmButtonText:  this.translateSrv.instant('LEADER_GO.SECCION_SELECT_LEADER.BTN_CONFI_YES'),
    cancelButtonText:   this.translateSrv.instant('LEADER_GO.SECCION_SELECT_LEADER.BTN_CONFI_NO'),
  }).then((result) => {
    if (result.value) {
      let r = Math.random().toString(36).substring(7);
      console.log("cadena de datos aleatorios: ",r);
      let codigo=r;
      Swal.fire({
        title: this.translateSrv.instant('LEADER_GO.SECCION_SELECT_LEADER.MSN_INGR_COD_ACTI_USER')+'<font color="red">'+codigo+'</font>'+this.translateSrv.instant('LEADER_GO.SECCION_SELECT_LEADER.MSN_INGR_COD2'),
        icon: 'info',
        input:'text',
        showCancelButton: true,
        reverseButtons: true,
        cancelButtonText: this.translateSrv.instant('LEADER_GO.SECCION_SELECT_LEADER.BTN_CONFI_CANCELAR'),
        confirmButtonText: this.translateSrv.instant('LEADER_GO.SECCION_SELECT_LEADER.BTN_CONFI_CONFIRMAR')
      }).then( (borrar) => {
        console.log('borrar',borrar);
        if (borrar.value==codigo) {
          let datos={
            status:event['checked']
          }
          console.log('datos',datos);
          this.modalGuardado(this.translateSrv.instant('LEADER_GO.SECCION_SELECT_LEADER.MOD_ACTI_USE_CGO'));
          this.leaderService.postUserStatusActionCGO(row.User_cgo,datos).subscribe( (data1: any) => {
            console.log('datos**********',data1);
            Swal.close();
            this.openSuccessSnackBar(this.translateSrv.instant('LEADER_GO.SECCION_SELECT_LEADER.SUCCE_UPDA_STA_USE'),'');
          });


        }
        else{
          this.dataSource.filteredData[index].statusLoginUser=!event['checked'];
          console.log(this.dataSource);
          Swal.fire({
          icon: 'error',
          title: this.translateSrv.instant('LEADER_GO.SECCION_SELECT_LEADER.MODAL_ERR_COD'),
          showConfirmButton: true,
          confirmButtonText: this.translateSrv.instant('LEADER_GO.SECCION_SELECT_LEADER.BTN_CONFI_OK')
          })
          // if (borrar.isConfirmed!=false) {
          // }

        }
      });

    }else{
      this.dataSource.filteredData[index].statusLoginUser=!event['checked'];;
    }
  });


}





enviarCorreosLideres(){
if (this.selection.selected.length>0) {
  this.leadresActionSeleccionados= this.selection.selected;
  console.log("leadresActionSeleccionados:",this.leadresActionSeleccionados);

  this.leadresActionSeleccionados.forEach(lider => {
    if(lider.native != null){
      let splitIdioma= lider.native.split('-');
      lider.native=splitIdioma[0];
    }
  });
  console.log('leadresActionSeleccionados part 2',this.leadresActionSeleccionados);
    Swal.fire({
      title: this.translateSrv.instant('LEADER_GO.SECCION_SELECT_LEADER.MODAL_CONFI_SEND_MAIL'),
      icon: 'warning',
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonText:  this.translateSrv.instant('LEADER_GO.SECCION_SELECT_LEADER.BTN_CONFI_YES'),
      cancelButtonText:   this.translateSrv.instant('LEADER_GO.SECCION_SELECT_LEADER.BTN_CONFI_NO'),
    }).then((result) => {
      if (result.value) {
        let r = Math.random().toString(36).substring(7);
        console.log("cadena de datos aleatorios: ",r);
        let codigo=r;
        Swal.fire({
          title: this.translateSrv.instant('LEADER_GO.SECCION_SELECT_LEADER.MSN_INGR_COD')+'<font color="red">'+codigo+'</font>'+this.translateSrv.instant('LEADER_GO.SECCION_SELECT_LEADER.MSN_INGR_COD2'),
          icon: 'info',
          input:'text',
          showCancelButton: true,
          reverseButtons: true,
          cancelButtonText: this.translateSrv.instant('LEADER_GO.SECCION_SELECT_LEADER.BTN_CONFI_CANCELAR'),
          confirmButtonText: this.translateSrv.instant('LEADER_GO.SECCION_SELECT_LEADER.BTN_CONFI_CONFIRMAR')
        })
        .then( (borrar) => {
          console.log(borrar);
          if (borrar.value==codigo) {
            let datos={
              productoId:localStorage.getItem('productoID'),
              usersActionGo:this.leadresActionSeleccionados
            }
            console.log('datos',datos);
            this.modalGuardado(this.translateSrv.instant('LEADER_GO.SECCION_SELECT_LEADER.MOD_INFO_SEN_EMA'));
            this.leaderService.enviarEmailLeadersAction(datos).subscribe( (data1: any) => {
              console.log('datos**********',data1);
              this.selection.clear();
              this.getLeadersActionGo(this.idEmpresa,this.productoCertificar.asociadoId);
              Swal.close();
              this.openSuccessSnackBar(this.translateSrv.instant('LEADER_GO.SECCION_SELECT_LEADER.SUCCE_SEN_EMA'),'');
            });
          }
          else{
            if(!borrar.dismiss){
              Swal.fire({
              icon: 'error',
              title: this.translateSrv.instant('LEADER_GO.SECCION_SELECT_LEADER.MODAL_ERR_COD'),
              showConfirmButton: true,
              confirmButtonText: this.translateSrv.instant('LEADER_GO.SECCION_SELECT_LEADER.BTN_CONFI_OK')
              })
            }

          }
        });

      }
    });

}else{
  Swal.fire({
  icon: 'warning',
  title: this.translateSrv.instant('LEADER_GO.SECCION_SELECT_LEADER.WARNI_NO_SELEC_LEA'),
  showConfirmButton: true,

  confirmButtonText: this.translateSrv.instant('LEADER_GO.SECCION_SELECT_LEADER.BTN_CONFI_OK')
  })
}
}

modalGuardado(mensaje?:any){
  Swal.fire({
    title: mensaje,
    allowOutsideClick: false,
    didOpen: () => {
      Swal.showLoading()
    }
  });
}

openSuccessSnackBar(message: string, action: string) {
   this.snackBar.open(message, action, {
      duration: 5000,
      panelClass: ['background-success']
   });
}

}
